<div class="tag-view">  
  <div class="section">
    <h3>Базовые теги</h3>
    <div class="tags-container">
      <pa-tag value="Основной" severity="primary"></pa-tag>
      <pa-tag value="Информация" severity="info"></pa-tag>
      <pa-tag value="Успех" severity="success"></pa-tag>
      <pa-tag value="Предупреждение" severity="warn"></pa-tag>
      <pa-tag value="Опасность" severity="danger"></pa-tag>
      <pa-tag value="Вторичный" severity="secondary"></pa-tag>
      <pa-tag value="Вторичный (subtle)" severity="secondary-subtle"></pa-tag>
      <pa-tag value="Вторичный (strong)" severity="secondary-strong"></pa-tag>
      <pa-tag value="Вторичный (muted)" severity="secondary-muted"></pa-tag>
      <pa-tag value="Успех (subtle)" severity="success-subtle"></pa-tag>
      <pa-tag value="Успех (strong)" severity="success-strong"></pa-tag>
      <pa-tag value="Контраст" severity="contrast"></pa-tag>
    </div>
  </div>

  <div class="section">
    <h3>Округленные теги</h3>
    <div class="tags-container">
      <pa-tag value="Основной" severity="primary" [rounded]="true"></pa-tag>
      <pa-tag value="Основной" severity="info" [rounded]="true"></pa-tag>
      <pa-tag value="Успех" severity="success" [rounded]="true"></pa-tag>
      <pa-tag value="Предупреждение" severity="warn" [rounded]="true"></pa-tag>
      <pa-tag value="Опасность" severity="danger" [rounded]="true"></pa-tag>
      <pa-tag value="Вторичный" severity="contrast" [rounded]="true"></pa-tag>
    </div>
  </div>

  <div class="section">
    <h3>Маленькие теги</h3>
    <div class="tags-container">
      <pa-tag value="Основной" severity="primary" size="small"></pa-tag>
      <pa-tag value="Основной" severity="info" size="small"></pa-tag>
      <pa-tag value="Успех" severity="success" size="small"></pa-tag>
      <pa-tag value="Предупреждение" severity="warn" size="small"></pa-tag>
      <pa-tag value="Опасность" severity="danger" size="small"></pa-tag>
      <pa-tag value="Вторичный" severity="contrast" size="small" [rounded]="true"></pa-tag>
    </div>
  </div>

  <div class="section">
    <h3>Маленькие и округленные теги</h3>
    <div class="tags-container">
      <pa-tag value="Основной" severity="primary" size="small" [rounded]="true"></pa-tag>
      <pa-tag value="Основной" severity="info" size="small" [rounded]="true"></pa-tag>
      <pa-tag value="Успех" severity="success" size="small" [rounded]="true"></pa-tag>
      <pa-tag value="Предупреждение" severity="warn" size="small" [rounded]="true"></pa-tag>
      <pa-tag value="Опасность" severity="danger" size="small" [rounded]="true"></pa-tag>
      <pa-tag value="Вторичный" severity="contrast" size="small" [rounded]="true"></pa-tag>
    </div>
  </div>

  <div class="section">
    <h3>Теги с иконками</h3>
    <div class="tags-container">
      <pa-tag value="Пользователь" severity="info" icon="pi pi-user"></pa-tag>
      <pa-tag value="Проверено" severity="success" icon="pi pi-check"></pa-tag>
      <pa-tag value="Внимание" severity="warn" icon="pi pi-exclamation-triangle"></pa-tag>
      <pa-tag value="Заблокирован" severity="danger" icon="pi pi-ban"></pa-tag>
      <pa-tag value="Вторичный" severity="contrast" icon="pi pi-user" [rounded]="true"></pa-tag>
    </div>
  </div>

  <div class="section">
    <h3>Кастомные стили</h3>
    <div class="tags-container">
      <pa-tag value="Большой" severity="info" [style]="{ 'font-size': '1.2em', 'padding': '0.5em 1em' }"></pa-tag>
      <pa-tag value="Большой" severity="success" [style]="{ 'font-size': '1.2em', 'padding': '0.5em 1em' }"></pa-tag>
      <pa-tag value="Большой" severity="warn" [style]="{ 'font-size': '1.2em', 'padding': '0.5em 1em' }"></pa-tag>
      <pa-tag value="Большой" severity="danger" [style]="{ 'font-size': '1.2em', 'padding': '0.5em 1em' }"></pa-tag>
      <pa-tag value="Вторичный" severity="contrast" [style]="{ 'font-size': '1.2em', 'padding': '0.5em 1em' }" [rounded]="true"></pa-tag>
    </div>
  </div>

  <div class="section">
    <h3>ПРОФИ</h3>
    <div class="tags-container">
      <pa-tag value="ПРОФИ" severity="profi"></pa-tag>
      <pa-tag severity="profi"></pa-tag>
    </div>
  </div>
</div> 